interface ILeftArrow {
  width?: number;
  height?: number;
  fill?: string;
}
export const LeftArrow = ({ width, height, fill }: ILeftArrow) => {
  const color = fill || '#1552E8';
  return (
    <svg
      width={width ?? 20}
      height={height ?? 20}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.2159 16.5C10.3892 16.5 10.5624 16.4384 10.6992 16.3064C10.9636 16.0512 10.9636 15.6289 10.6992 15.3737L5.6482 10.4989L10.6992 5.62411C10.9636 5.36893 10.9636 4.94656 10.6992 4.69138C10.4348 4.43621 9.99713 4.43621 9.73273 4.69138L4.19856 10.0325C3.93416 10.2877 3.93416 10.7101 4.19856 10.9653L9.73273 16.3064C9.86949 16.4384 10.0427 16.5 10.2159 16.5Z'
        fill={color}
      />
      <path
        d='M4.83538 11.1636H15.3172C15.691 11.1636 16.001 10.8645 16.001 10.5037C16.001 10.1429 15.691 9.84375 15.3172 9.84375H4.83538C4.46157 9.84375 4.15158 10.1429 4.15158 10.5037C4.15158 10.8645 4.46157 11.1636 4.83538 11.1636Z'
        fill={color}
      />
    </svg>
  );
};
